import React from 'react';

interface IProps {
  className?: string,
  width?: string | number,
  footerValue?: string | number | React.ReactNode,
  isVisible?: boolean,
  dataTest?: string,
}

const FooterCell = ({
  className = '',
  width = 'auto',
  footerValue = '',
  isVisible = true,
  dataTest,
}: IProps) => (isVisible ? (
  <td
    className={ className }
    style={ { width } }
    data-test={ dataTest }
  >
    { footerValue }
  </td>
) : null);

export default FooterCell;
